import { render, staticRenderFns } from "./BreadCrump.vue?vue&type=template&id=dccb4846&scoped=true"
import script from "./BreadCrump.vue?vue&type=script&lang=js"
export * from "./BreadCrump.vue?vue&type=script&lang=js"
import style0 from "./BreadCrump.vue?vue&type=style&index=0&id=dccb4846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccb4846",
  null
  
)

export default component.exports